import { CSSProperties, FC, useCallback } from 'react';
import { useAssistantApi, useAssistantState } from '@assistant-ui/react';
import * as R from 'ramda';

import { Button, Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import { useChatContext } from './ChatContext';

import classes from './chat.module.css';

const styles: Record<string, CSSProperties> = {
  button: {
    textTransform: 'initial',
  },
};

const ChatError: FC = () => {
  const { error } = useChatContext();
  const { messages } = useAssistantState(state => state.thread);
  const api = useAssistantApi();
  const runtime = api.thread();

  const handleRetry = useCallback(() => {
    const userMessages = messages.filter(message => message.role === 'user');
    const userMessage = R.last(userMessages);

    if (userMessage) {
      runtime.append({
        role: 'user',
        content: userMessage.content,
      });
    }
  }, [messages, runtime]);

  if (!error) {
    return null;
  }

  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorContent}>
        <Icon color={colors.utility.error} className={classes.errorIcon}>
          error
        </Icon>
        <div className={classes.errorTextContainer}>
          <div className={classes.errorTitle}>Something went wrong</div>
          <div className={classes.errorMessage}>
            Sorry, I wasn't able to get a response to your question. Please try
            again.
          </div>
        </div>
        <Button sx={styles.button} variant="text" onClick={handleRetry}>
          Try again
        </Button>
      </div>
    </div>
  );
};

export default ChatError;
